/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One column of items per set, with the set name in the first row. The tool compares the columns to count unique and shared items.`)
};

const es_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una columna de elementos por conjunto, con el nombre del conjunto en la primera fila. La herramienta compara las columnas para contar elementos únicos y compartidos.`)
};

const de_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Spalte mit Elementen pro Menge, mit dem Mengennamen in der ersten Zeile. Das Tool vergleicht die Spalten, um eindeutige und gemeinsame Elemente zu zählen.`)
};

const nl_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén kolom items per set, met de setnaam in de eerste rij. De tool vergelijkt de kolommen om unieke en gedeelde items te tellen.`)
};

const fr_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une colonne d'éléments par ensemble, avec le nom de l'ensemble dans la première ligne. L'outil compare les colonnes pour compter les éléments uniques et partagés.`)
};

const it_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una colonna di elementi per insieme, con il nome dell'insieme nella prima riga. Lo strumento confronta le colonne per contare elementi unici e condivisi.`)
};

const pt_br2_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna de itens por conjunto, com o nome do conjunto na primeira linha. A ferramenta compara as colunas para contar itens exclusivos e compartilhados.`)
};

const pt_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma coluna de itens por conjunto, com o nome do conjunto na primeira linha. A ferramenta compara as colunas para contar itens únicos e partilhados.`)
};

const ja_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集合ごとに項目を1列、1行目に集合名を入れます。ツールは各列を比較して固有の項目数と共有項目数を数えます。`)
};

const zh_venn_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个集合一列项目，第一行为集合名称。工具会比较各列以计算独有和共享的项目数量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_a1", locale)
	if (locale === "en") return en_venn_faq_a1(inputs)
	if (locale === "es") return es_venn_faq_a1(inputs)
	if (locale === "de") return de_venn_faq_a1(inputs)
	if (locale === "nl") return nl_venn_faq_a1(inputs)
	if (locale === "fr") return fr_venn_faq_a1(inputs)
	if (locale === "it") return it_venn_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_a1(inputs)
	if (locale === "pt") return pt_venn_faq_a1(inputs)
	if (locale === "ja") return ja_venn_faq_a1(inputs)
	return zh_venn_faq_a1(inputs)
};